var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gear"},_vm._l((_vm.gears),function(gear,index){return _c('span',{key:index,staticClass:"position",class:{active: gear === _vm.position}},[_vm._v(_vm._s(gear))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }